import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx, _cache) {
  const _component_ListEvent = _resolveComponent("ListEvent")
  const _component_Slide = _resolveComponent("Slide")
  const _component_Carousel = _resolveComponent("Carousel")

  return (_ctx.layout === 'list')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.getClass('list-container')),
        style: _normalizeStyle(_ctx.styleScrollView)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (item, pos) => {
          return (_openBlock(), _createBlock(_component_ListEvent, {
            key: pos,
            component: item,
            layout: _ctx.layout,
            structure: _ctx.type,
            settings: _ctx.componentSettings
          }, null, 8 /* PROPS */, ["component", "layout", "structure", "settings"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 6 /* CLASS, STYLE */))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(_ctx.getClass('carousel-wrapper')),
        ref: "carouselWrapper",
        style: _normalizeStyle(_ctx.styleScrollView)
      }, [
        _createVNode(_component_Carousel, _mergeProps(_ctx.carouselSettings, {
          ref: "carouselContainer",
          onSlideEnd: _ctx.onChangeCarousel
        }), {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (item, pos) => {
              return (_openBlock(), _createBlock(_component_Slide, { key: pos }, {
                default: _withCtx(() => [
                  _createVNode(_component_ListEvent, {
                    component: item,
                    layout: _ctx.layout,
                    structure: _ctx.type,
                    settings: _ctx.componentSettings
                  }, null, 8 /* PROPS */, ["component", "layout", "structure", "settings"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */, ["onSlideEnd"]),
        (_ctx.showPrev)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(_ctx.getClass('arrow_left')),
              onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.navPrev && _ctx.navPrev(...args)))
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512"
              }, [
                _createElementVNode("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" })
              ], -1 /* HOISTED */)
            ]), 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        (_ctx.showNext)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: _normalizeClass(_ctx.getClass('arrow_right')),
              onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.navNext && _ctx.navNext(...args)))
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512"
              }, [
                _createElementVNode("path", { d: "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" })
              ], -1 /* HOISTED */)
            ]), 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], 6 /* CLASS, STYLE */))
}